import { sessionRevoked } from './session';

/** Non-content marker survives a wipe. Each tab binds once, before requests;
 * observing a newer login marker must never adopt that login's authority. */
export const PRIVATE_EPOCH_KEY = 'gorodn_private_epoch';
function storedEpoch(): string | null {
  try { return localStorage.getItem(PRIVATE_EPOCH_KEY); } catch { return null; }
}
function persist(epoch: string): void {
  try { localStorage.setItem(PRIVATE_EPOCH_KEY, epoch); } catch { /* private mode */ }
}
const initial = storedEpoch();
let fallback = initial ?? crypto.randomUUID();
let bound = fallback;
if (!initial) persist(bound);
export class PrivacyContextChanged extends Error {
  constructor() { super('The session changed. This action was not saved or queued.'); this.name = 'PrivacyContextChanged'; }
}
export const privateEpoch = (): string => bound;
export function advancePrivateEpoch(): void {
  fallback = crypto.randomUUID();
  persist(fallback);
}
/** Only an explicit successful auth boundary may rebind this tab. Old promises
 * retain their captured epoch, so they remain invalid after a new login. */
export function bindPrivateSession(): void { bound = storedEpoch() ?? fallback; }
export function privateEpochActive(epoch: string): boolean {
  return !sessionRevoked() && epoch === bound && epoch === (storedEpoch() ?? fallback);
}
export function requirePrivateEpoch(epoch: string): void {
  if (!privateEpochActive(epoch)) throw new PrivacyContextChanged();
}
